var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EditCard',{ref:"editCard",attrs:{"visible":_vm.dialogVisible,"card":_vm.editingCard,"collections":_vm.collections,"preselectedCollectionId":_vm.preselectedCollectionId},on:{"update:visible":function($event){_vm.dialogVisible=$event},"saved":_vm.handleSaved,"close":_vm.handleClose}})
}
var staticRenderFns = []

export { render, staticRenderFns }